import { render, staticRenderFns } from "./add-preset.vue?vue&type=template&id=5de2b480&"
import script from "./add-preset.vue?vue&type=script&lang=js&"
export * from "./add-preset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports